import {Box, Typography} from '@mui/material';
import React from 'react';
import {AppBreadcrumbs} from '../../navigation/layout';

type PageContainerProps = {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  showBreadcrumbs?: boolean;
  stationName?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | false;
  children: React.ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({
  title,
  subtitle,
  actions,
  showBreadcrumbs = false,
  stationName,
  maxWidth = false,
  children,
}) => {
  const maxWidthValue = maxWidth
    ? {
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      }[maxWidth]
    : undefined;

  return (
    <Box
      sx={{
        maxWidth: maxWidthValue,
        mx: maxWidth ? 'auto' : 0,
        width: '100%',
      }}>
      {/* Breadcrumbs */}
      {showBreadcrumbs && <AppBreadcrumbs stationName={stationName} />}

      {/* Header section */}
      {(title || actions) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: {xs: 'column', sm: 'row'},
            justifyContent: 'space-between',
            alignItems: {xs: 'flex-start', sm: 'center'},
            gap: 2,
            mb: 3,
          }}>
          <Box>
            {title && (
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: 600,
                  color: 'text.primary',
                }}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{mt: 0.5}}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions && (
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                flexShrink: 0,
              }}>
              {actions}
            </Box>
          )}
        </Box>
      )}

      {/* Main content */}
      {children}
    </Box>
  );
};

export default PageContainer;
